export const audienceMembershipAr = {
  title: 'عضويات نادي حلول العقاري العالمي',
  intro: [
    'تقوم عضويات نادي حلول العقاري العالمي على نظام ذكي صُمم ليمنح الأعضاء قيمة حقيقية وتوفيرًا ملموسًا داخل منظومة عقارية دولية متكاملة. وتنقسم العضويات إلى ثلاث فئات رئيسية: الأفراد، والرواد، والنخبة، بحيث يحصل كل عضو على باقة من العمليات المشمولة بدون عمولة النادي، إلى جانب مزايا وخدمات مختارة تختلف بحسب مستوى العضوية.',
    'يعتمد النادي على عمولة صفر على العمليات المشمولة، مع وجود رسوم خدمات منفصلة لبعض الخدمات المختارة، ويتم تخفيضها أو إعفاؤها أو تقليلها بحسب الفئة العضوية، بما يحقق أفضل استفادة ممكنة للأعضاء ويمنحهم تجربة أكثر كفاءة ووضوحًا داخل المنظومة.',
  ],
  annualFeeLabel: 'الرسوم السنوية',
  operationsLabel: 'العمليات المشمولة',
  tableHeaders: ['الخدمة المشمولة', 'ما الذي يحصل عليه العضو؟', 'القيمة المضافة'],
  tiers: [
    {
      id: 'individuals',
      label: 'الأفراد',
      icon: 'person',
      thumb: `${process.env.PUBLIC_URL}/images/indevidiuals.jfif`,
      image:
        'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'عضوية الأفراد',
      annualFee: '500 دولار',
      operations: '3 عمليات بيع أو شراء أو إيجار بدون عمولة النادي',
      services: [
        {
          service: 'تقييم مبدئي للعقار',
          benefit: 'قراءة أولية تساعد العضو على فهم الوضع السوقي للعقار قبل القرار',
          value: 'يقلل المخاطرة ويمنح رؤية أوضح قبل الشراء أو البيع',
        },
        {
          service: 'مراجعة قانونية أولية',
          benefit: 'مراجعة مختصرة للبنود أو الملفات القانونية الأساسية',
          value: 'تمنح طمأنينة أولية وتقلل الأخطاء الشائعة',
        },
        {
          service: 'تنسيق مع الشركات المعتمدة',
          benefit: 'إحالة مباشرة إلى شركاء النادي المعتمدين',
          value: 'يوفر الوقت والجهد ويزيد الثقة في جهة الخدمة',
        },
        {
          service: 'عروض وخصومات من الشركاء',
          benefit: 'خصومات حصرية من بعض مقدمي الخدمات داخل الشبكة',
          value: 'يحقق وفراً إضافيًا في التكاليف',
        },
        {
          service: 'أولوية الاطلاع على الفرص',
          benefit: 'وصول مبكر إلى بعض العروض والفرص داخل المنصة',
          value: 'يمنحه فرصة أسرع قبل الآخرين',
        },
      ],
      coreValueTitle: 'القيمة الأساسية لعضوية الأفراد',
      coreValue:
        'دخول سهل إلى المنظومة + 3 عمليات بدون عمولة النادي + خدمات أساسية وخصومات حصرية تساعد العضو على التحرك بثقة وتكلفة أقل.',
    },
    {
      id: 'pioneers',
      label: 'الرواد',
      icon: 'rocket_launch',
      thumb: `${process.env.PUBLIC_URL}/images/pioneers.jfif`,
      image:
        'https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'عضوية الرواد',
      annualFee: '1,500 دولار',
      operations: '4 عمليات بيع أو شراء أو إيجار بدون عمولة النادي',
      services: [
        {
          service: 'تقييم تفصيلي للعقار',
          benefit: 'تقييم أعمق وأوضح يساعد على اتخاذ قرار أفضل',
          value: 'يمنح صورة أكثر دقة عن القيمة والفرصة',
        },
        {
          service: 'مراجعة قانونية موسعة',
          benefit: 'مراجعة أوسع للبنود والمخاطر الأساسية',
          value: 'ترفع درجة الأمان القانوني وتقلل المفاجآت',
        },
        {
          service: 'استشارة تمويل أولية',
          benefit: 'توجيه مبدئي حول خيارات التمويل أو الهيكلة',
          value: 'تساعد على فهم البدائل المتاحة قبل التعاقد',
        },
        {
          service: 'تنسيق محسن مع الشركات المعتمدة',
          benefit: 'متابعة أفضل مع شركاء النادي',
          value: 'يضمن خدمة أسرع وأكثر تنظيمًا',
        },
        {
          service: 'إدارة أملاك أساسية',
          benefit: 'دعم أولي في متابعة الأصل أو تشغيله',
          value: 'يفيد من يرغب في الاحتفاظ بالعقار أو استثماره',
        },
        {
          service: 'الصيانة والتشطيب',
          benefit: 'تنسيق مع شركاء متخصصين في التنفيذ',
          value: 'يسهل الوصول إلى أفضل مقدمي الخدمة',
        },
        {
          service: 'استشارات محاسبية وضريبية أولية',
          benefit: 'دعم مبدئي في الجوانب المالية والضريبية',
          value: 'يساعد على فهم التكلفة الحقيقية وإدارة التدفق المالي',
        },
        {
          service: 'خدمات الإقامة والهجرة',
          benefit: 'وصول إلى شركاء مختصين في الحلول الدولية',
          value: 'قيمة إضافية لمن يحتاج إلى ترتيبات دولية',
        },
      ],
      coreValueTitle: 'القيمة الأساسية لعضوية الرواد',
      coreValue:
        '4 عمليات بدون عمولة النادي + حزمة أوسع من الخدمات + خصومات ومزايا أعلى + مستوى دعم أفضل داخل الشبكة.',
    },
    {
      id: 'elite',
      label: 'النخبة',
      icon: 'diamond',
      thumb: `${process.env.PUBLIC_URL}/images/elite.jpeg`,
      image:
        'https://images.pexels.com/photos/1486222/pexels-photo-1486222.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'عضوية النخبة',
      annualFee: '3,000 دولار',
      operations: '5 عمليات بيع أو شراء أو إيجار بدون عمولة النادي',
      services: [
        {
          service: 'تقييم متقدم للعقار',
          benefit: 'قراءة أكثر احترافية وعمقًا للحالات المهمة',
          value: 'مناسب للفرص عالية القيمة أو الحساسة',
        },
        {
          service: 'مراجعة قانونية شاملة',
          benefit: 'مراجعة دقيقة وأوسع للوثائق والبنود',
          value: 'تمنح مستوى أعلى من الحماية والوضوح',
        },
        {
          service: 'استشارة تمويل وهيكلة',
          benefit: 'دعم في التمويل وتنظيم الصفقة أو الفكرة الاستثمارية',
          value: 'يساعد على اتخاذ قرار أقوى وأكثر احترافية',
        },
        {
          service: 'تنسيق مباشر مع الشركاء المعتمدين',
          benefit: 'أولوية أعلى في الوصول إلى شركاء النادي',
          value: 'يضمن سرعة في التنفيذ وجودة في الاختيار',
        },
        {
          service: 'إدارة أملاك متقدمة',
          benefit: 'مستوى أوسع من الدعم في الإدارة والمتابعة',
          value: 'يفيد المستثمرين وأصحاب المحافظ العقارية',
        },
        {
          service: 'الصيانة والتشطيب المتخصص',
          benefit: 'وصول إلى شركاء أكثر تخصصًا وتميّزًا',
          value: 'يرفع جودة التنفيذ والخدمة',
        },
        {
          service: 'المحاسبة والضرائب',
          benefit: 'دعم أوسع في الجوانب المالية والضريبية',
          value: 'مهم للقرارات الكبيرة والاستثمارات المتعددة',
        },
        {
          service: 'خدمات الإقامة والهجرة والجنسية',
          benefit: 'وصول أفضل إلى حلول دولية متقدمة',
          value: 'قيمة عالية لمن لديهم احتياجات دولية',
        },
        {
          service: 'دراسة الجدوى',
          benefit: 'دعم مبدئي أو موجه في الجدوى حسب الحالة',
          value: 'مهم للشركات والمشروعات والاستثمارات',
        },
        {
          service: 'الدعاية والتسويق',
          benefit: 'دعم أو تنسيق تسويقي للمشروعات المرتبطة',
          value: 'يضيف قيمة تجارية وإعلامية قوية',
        },
      ],
      coreValueTitle: 'القيمة الأساسية لعضوية النخبة',
      coreValue:
        '5 عمليات بدون عمولة النادي + باقة متقدمة من الخدمات + أولوية أعلى داخل الشبكة + تجربة نخبوية أكثر تكاملًا واحترافية.',
    },
  ],
  excludedTitle: 'الخدمات الاستثمارية ذات الرسوم واللوائح الخاصة',
  excludedIntro:
    'حرصاً على تقديم أعلى درجات الكفاءة والتخصص، تقدم منظومة "نادي حلول العقاري العالمي" بعض الخدمات الاستثمارية المتقدمة وفق أطر تنظيمية ورسوم مستقلة خارج نطاق باقات العمليات المشمولة في العضويات، وتتضمن:',
  excludedHeaders: ['الخدمة', 'الملاحظات'],
  excluded: [
    {
      service: 'المزادات العقارية الدولية',
      note: 'منظومة بيع وتنفيذ مستقلة تُدار وفق لوائح ورسوم تشغيلية خاصة لضمان التنافسية وأعلى العوائد.',
    },
    {
      service: 'التبادل العقاري عابر للحدود',
      note: 'خدمة هيكلة صفقات المقايضة والاستبدال العقاري الدولي، وتخضع لنظام تقييم ورسوم مستقلة.',
    },
  ],
  summaryTitle: 'الخلاصة المختصرة',
  summary:
    'توفر عضويات نادي حلول العقاري العالمي وصولًا إلى منظومة عقارية دولية متكاملة، مع عمولة صفر على العمليات المشمولة، ورسوم خدمات منفصلة ومخففة أو معفاة بحسب الفئة، إلى جانب خصومات حصرية ومزايا متدرجة تمنح كل عضو قيمة حقيقية تتناسب مع مستوى عضويته.',
};

export const audienceMembershipEn = {
  title: 'Holol Global Real Estate Club memberships',
  intro: [
    'Holol Global Real Estate Club memberships are built on a smart system designed to deliver real value and tangible savings within an integrated international real estate ecosystem. Memberships are divided into three main categories — Individuals, Pioneers, and Elite — so each member receives a package of covered transactions with zero club commission, along with selected benefits and services that vary by membership level.',
    'The club applies zero commission on covered transactions, with separate service fees for certain selected services that are reduced, waived, or discounted according to membership tier — maximizing member benefit and delivering a more efficient, transparent experience within the ecosystem.',
  ],
  annualFeeLabel: 'Annual fee',
  operationsLabel: 'Covered transactions',
  tableHeaders: ['Included service', 'What does the member receive?', 'Added value'],
  tiers: [
    {
      id: 'individuals',
      label: 'Individuals',
      icon: 'person',
      thumb: `${process.env.PUBLIC_URL}/images/indevidiuals.jfif`,
      image:
        'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'Individual membership',
      annualFee: '$500',
      operations: '3 sale, purchase, or lease transactions with zero club commission',
      services: [
        {
          service: 'Initial property appraisal',
          benefit: 'A preliminary review that helps the member understand market conditions before deciding',
          value: 'Reduces risk and provides clearer insight before buying or selling',
        },
        {
          service: 'Initial legal review',
          benefit: 'A concise review of key clauses or basic legal files',
          value: 'Provides initial reassurance and reduces common mistakes',
        },
        {
          service: 'Coordination with accredited companies',
          benefit: 'Direct referral to the club\'s accredited partners',
          value: 'Saves time and effort and increases confidence in the service provider',
        },
        {
          service: 'Partner offers and discounts',
          benefit: 'Exclusive discounts from selected service providers within the network',
          value: 'Delivers additional cost savings',
        },
        {
          service: 'Priority access to opportunities',
          benefit: 'Early access to selected offers and opportunities on the platform',
          value: 'Gives a faster chance before others',
        },
      ],
      coreValueTitle: 'Core value of Individual membership',
      coreValue:
        'Easy entry into the ecosystem + 3 zero-commission transactions + essential services and exclusive discounts that help members move with confidence at lower cost.',
    },
    {
      id: 'pioneers',
      label: 'Pioneers',
      icon: 'rocket_launch',
      thumb: `${process.env.PUBLIC_URL}/images/pioneers.jfif`,
      image:
        'https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'Pioneer membership',
      annualFee: '$1,500',
      operations: '4 sale, purchase, or lease transactions with zero club commission',
      services: [
        {
          service: 'Detailed property appraisal',
          benefit: 'A deeper, clearer appraisal that supports better decision-making',
          value: 'Provides a more accurate picture of value and opportunity',
        },
        {
          service: 'Extended legal review',
          benefit: 'A broader review of clauses and key risks',
          value: 'Raises legal safety and reduces surprises',
        },
        {
          service: 'Initial financing consultation',
          benefit: 'Introductory guidance on financing or structuring options',
          value: 'Helps understand available alternatives before contracting',
        },
        {
          service: 'Enhanced coordination with accredited companies',
          benefit: 'Better follow-up with club partners',
          value: 'Ensures faster, better-organized service',
        },
        {
          service: 'Basic property management',
          benefit: 'Initial support in monitoring or operating the asset',
          value: 'Benefits those who wish to hold or invest in the property',
        },
        {
          service: 'Maintenance and finishing',
          benefit: 'Coordination with specialized execution partners',
          value: 'Makes it easier to reach top service providers',
        },
        {
          service: 'Initial accounting and tax consultation',
          benefit: 'Introductory support on financial and tax aspects',
          value: 'Helps understand true cost and manage cash flow',
        },
        {
          service: 'Residency and immigration services',
          benefit: 'Access to partners specialized in international solutions',
          value: 'Added value for those needing international arrangements',
        },
      ],
      coreValueTitle: 'Core value of Pioneer membership',
      coreValue:
        '4 zero-commission transactions + a wider service package + higher discounts and benefits + better support within the network.',
    },
    {
      id: 'elite',
      label: 'Elite',
      icon: 'diamond',
      thumb: `${process.env.PUBLIC_URL}/images/elite.jpeg`,
      image:
        'https://images.pexels.com/photos/1486222/pexels-photo-1486222.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'Elite membership',
      annualFee: '$3,000',
      operations: '5 sale, purchase, or lease transactions with zero club commission',
      services: [
        {
          service: 'Advanced property appraisal',
          benefit: 'A more professional, in-depth review for important cases',
          value: 'Suited to high-value or sensitive opportunities',
        },
        {
          service: 'Comprehensive legal review',
          benefit: 'A precise, broader review of documents and clauses',
          value: 'Provides a higher level of protection and clarity',
        },
        {
          service: 'Financing and structuring consultation',
          benefit: 'Support with financing and deal or investment structuring',
          value: 'Supports stronger, more professional decisions',
        },
        {
          service: 'Direct coordination with accredited partners',
          benefit: 'Higher priority access to club partners',
          value: 'Ensures speed in execution and quality in selection',
        },
        {
          service: 'Advanced property management',
          benefit: 'A broader level of management and follow-up support',
          value: 'Benefits investors and portfolio owners',
        },
        {
          service: 'Specialized maintenance and finishing',
          benefit: 'Access to more specialized, distinguished partners',
          value: 'Raises execution and service quality',
        },
        {
          service: 'Accounting and taxes',
          benefit: 'Broader support on financial and tax aspects',
          value: 'Important for major decisions and multiple investments',
        },
        {
          service: 'Residency, immigration, and citizenship services',
          benefit: 'Better access to advanced international solutions',
          value: 'High value for those with international needs',
        },
        {
          service: 'Feasibility study',
          benefit: 'Introductory or guided feasibility support as needed',
          value: 'Important for companies, projects, and investments',
        },
        {
          service: 'Publicity and marketing',
          benefit: 'Marketing support or coordination for related projects',
          value: 'Adds strong commercial and media value',
        },
      ],
      coreValueTitle: 'Core value of Elite membership',
      coreValue:
        '5 zero-commission transactions + an advanced service package + higher priority within the network + a more integrated, professional elite experience.',
    },
  ],
  excludedTitle: 'Investment services with their own fees and regulations',
  excludedIntro:
    'To keep every service at the highest level of efficiency and specialisation, Holol Global Real Estate Club offers certain advanced investment services under independent regulations and fees, outside the transaction packages covered by membership. These are:',
  excludedHeaders: ['Service', 'Notes'],
  excluded: [
    {
      service: 'International real estate auctions',
      note: 'An independent sale and execution system, run under its own regulations and operating fees to secure competition and the highest returns.',
    },
    {
      service: 'Cross-border property exchange',
      note: 'A service that structures international barter and property-swap deals, under its own valuation system and fees.',
    },
  ],
  summaryTitle: 'Brief summary',
  summary:
    'Holol Global Real Estate Club memberships provide access to an integrated international real estate ecosystem, with zero commission on covered transactions and separate service fees that are reduced or waived by tier — alongside exclusive discounts and graduated benefits that give every member real value matched to their membership level.',
};
